import { useEffect } from "react";
import { Grid, Typography, Divider, Box } from "@mui/material";
import { InputField, SelectField } from "../../../../utils/FormFields";
import {
  AddUserDoctorRequestUserBloodTypeEnum,
  AddUserDoctorRequestUserGenderEnum,
  AddUserDoctorRequestUserMaritalStatusEnum,
} from "../../../../api/clinic-management";
import keyLabel from "../../../../utils/keylabel";
import DatePicker from "../../../../utils/FormFields/DatePicker";
import { useLocation } from "react-router";
import { useRecoilValue } from "recoil";
import { branchRoles } from "../../../../recoil/atoms";
import { FormikProps, FormikValues, useFormikContext } from "formik";
import UploadField from "../../../../utils/FormFields/UploadField";
import { FileBodyTypeEnum } from "../../../../api/file-management";

const bloodTypes = keyLabel(AddUserDoctorRequestUserBloodTypeEnum);
const gender = keyLabel(AddUserDoctorRequestUserGenderEnum);
const maritalStatus = keyLabel(AddUserDoctorRequestUserMaritalStatusEnum);

type Props = {
  roleOptions?: Object;
  defaultRole?: any;
  disabled?: Boolean;
};

export default function EmployeeInfo({ disabled }: Props) {
  const location = useLocation();
  const { setFieldValue } = useFormikContext();
  const formik: FormikProps<FormikValues> = useFormikContext();

  const availableRoles = useRecoilValue(branchRoles);
  const role: any = location.state;
  const defaultRole = availableRoles?.find((item) => item?.Name === role?.Name);
  const unavailableRoles = ["Developer","Owner"];
  const roleOptions = availableRoles?.filter((item)=>{
    if(location.pathname==="/employee/add"){
      return !unavailableRoles.includes(item.Name);
    }
    else{return item;}
  })
      .map((item) => {
    return { value: item.RoleID, label: item.Name };
  });

  useEffect(() => {
    if (formik.values?.Employee?.RoleID === undefined) setFieldValue("Employee.RoleID", role?.RoleID);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Typography variant="h5" gutterBottom sx={{ p: 0 }}>
        Employee Info
      </Typography>
      <Divider />
      <Grid container spacing={4} sx={{ pt: 8, pl: 2 }}>
        <Grid xs={12} sm={4}>
          <Box sx={{ pl: 1, pt: 2 }}>
            <InputField name="User.FirstName" label="First Name" fullWidth />
          </Box>
        </Grid>
        <Grid xs={12} sm={4}>
          <Box sx={{ pl: 1, pt: 2 }}>
            <InputField name="User.MiddleName" label="Middle Name" fullWidth />
          </Box>
        </Grid>
        <Grid xs={12} sm={4}>
          <Box sx={{ pl: 1, pt: 2 }}>
            <InputField name="User.FamilyName" label="Family Name" fullWidth />
          </Box>
        </Grid>

        <Grid xs={12} sm={4}>
          <Box sx={{ pl: 1, pt: 2 }}>
            <InputField name="User.MotherName" label="Mother Name" fullWidth />
          </Box>
        </Grid>
        <Grid xs={12} sm={4}>
          <Box sx={{ pl: 1, pt: 2 }}>
            <DatePicker name="User.DateOfBirth" label="Date Of Birth" />
          </Box>
        </Grid>
        <Grid xs={12} sm={2}>
          <Box sx={{ pl: 1, pt: 2 }}>
            <SelectField
              name="User.Gender"
              label="Gender"
              data={gender}
              type={AddUserDoctorRequestUserGenderEnum}
              fullWidth
            />
          </Box>
        </Grid>
        <Grid xs={12} sm={2}>
          <Box sx={{ pl: 1, pt: 2 }}>
            <SelectField
              name="User.BloodType"
              label="Blood Type"
              data={bloodTypes}
              type={AddUserDoctorRequestUserBloodTypeEnum}
              fullWidth
            />
          </Box>  
        </Grid>
        <Grid xs={12} sm={10}>
          <Box sx={{ pl: 1, pt: 2 }}>
            <InputField name="Employee.Speciality" label="Speciality" fullWidth />
          </Box>  
        </Grid>
        <Grid xs={12} sm={2}>
          <Box sx={{ pl: 1, pt: 2 }}>
            <SelectField
              name="Employee.RoleID"
              label="Role"
              data={roleOptions}
              defaultValue={defaultRole?.RoleID}
              fullWidth
              disabled={disabled}
            />
          </Box>
        </Grid>
      </Grid>
      <Typography variant="h5" gutterBottom sx={{ pt: 6 }}>
        Identity
      </Typography>
      <Divider />
      <Grid container spacing={4} sx={{ pt: 6, pl: 2 }}>
        <Grid xs={12} sm={2} md={3}>
          <Box sx={{ pl: 1, pt: 2 }}>
            <SelectField
              name="User.MaritalStatus"
              label="Marital Status"
              data={maritalStatus}
              type={AddUserDoctorRequestUserMaritalStatusEnum}
              fullWidth
            />
          </Box>  
        </Grid>
        <Grid xs={12} sm={4}>
          <Box sx={{ pl: 1, pt: 2 }}>
            <InputField name="User.Identity.IdentityID" label="Identity ID" fullWidth />
          </Box>  
        </Grid>
        <Grid xs={12} sm={2}>
          <Box sx={{ pl: 1, pt: 2 }}>
            <UploadField
              name="User.Identity.IdentityImageUri"
              label="Identity Image"
              fileType={FileBodyTypeEnum.USERIDENTITYIMAGE}
              fullWidth
            />
          </Box>  
        </Grid>
      </Grid>
    </>
  );
}
